import React, { useMemo } from "react";
import "./FeaturesPanel.css";
import { Link } from "react-router-dom";

/* ========= PREMIUM ICONS (stroke, clean) ========= */
const CoursesIcon = () => (
  <svg viewBox="0 0 24 24" className="fpIconSvg" aria-hidden="true">
    <path
      d="M4 6.8c0-1.2 1-2.2 2.2-2.2h11.1c1.2 0 2.2 1 2.2 2.2V18a1.6 1.6 0 0 1-1.6 1.6H6.3A2.3 2.3 0 0 0 4 21V6.8Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.6h7.6M8 11.6h7.6M8 14.6h4.4"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </svg>
);

const OutcomesIcon = () => (
  <svg viewBox="0 0 24 24" className="fpIconSvg" aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.75" />
    <circle cx="12" cy="12" r="3.1" fill="none" stroke="currentColor" strokeWidth="1.75" />
    <path
      d="M17.6 6.4 21 5l-1.4 3.4"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FeaturesPanel = () => {
  const courses = useMemo(
    () => [
      { title: "Data Science", sub: "Python • SQL • Stats" },
      { title: "Machine Learning", sub: "Models • Metrics" },
      { title: "Deep Learning", sub: "CNN • Transfer" },
      { title: "GenAI + LLMs", sub: "RAG • Agents" },
      { title: "MLOps", sub: "Deploy • AWS" },
      { title: "Internship", sub: "Mentor-led" },
    ],
    []
  );

  const stories = useMemo(
    () => [
      { name: "Vinay", role: "Data Analyst", metric: "₹8.5 LPA", tag: "Placement" },
      { name: "Trisha", role: "AI Engineer", metric: "₹7.9 LPA", tag: "Career Switch" },
      { name: "Afseen", role: "Cloud + ML", metric: "₹7.8 LPA", tag: "Cloud + ML" },
      { name: "Poorna", role: "Cloud + ML", metric: "₹8 LPA", tag: "Cloud + ML" },
    ],
    []
  );

  const loopCourses = useMemo(() => [...courses, ...courses], [courses]);
  const loopStories = useMemo(() => [...stories, ...stories], [stories]);

  return (
    <div className="features-panel fpLift">
      {/* COURSES */}
      <div className="fpCard fpCard--course">
        <div className="fpRim" aria-hidden="true" />
        <div className="fpSheen" aria-hidden="true" />
        <div className="fpNoise" aria-hidden="true" />

        <div className="fpTop">
          <div className="fpIcon fpIcon--course" aria-hidden="true">
            <CoursesIcon />
          </div>

          <div className="fpHead">
            <span className="fpPill">Programs</span>
            <h3 className="fpTitle">Explore Courses</h3>
            <p className="fpDesc">
              Projects + mentorship + a roadmap that ships skills.
            </p>
          </div>
        </div>

        <div className="fpStrip" aria-label="Programs strip">
          <div className="fpTrack fpTrack--course">
            {loopCourses.map((c, i) => (
              <div className="fpTile fpTile--course" key={`${c.title}-${i}`}>
                <div className="fpTileTitle">{c.title}</div>
                <div className="fpTileSub">{c.sub}</div>
              </div>
            ))}
          </div>
        </div>

        <Link to="/coursespage" className="fpBtn fpBtn--course">
          View All Courses <span aria-hidden="true">→</span>
        </Link>
      </div>

      {/* OUTCOMES */}
      <div className="fpCard fpCard--outcomes">
        <div className="fpRim" aria-hidden="true" />
        <div className="fpSheen" aria-hidden="true" />
        <div className="fpNoise" aria-hidden="true" />

        <div className="fpTop">
          <div className="fpIcon fpIcon--outcomes" aria-hidden="true">
            <OutcomesIcon />
          </div>

          <div className="fpHead">
            <span className="fpPill fpPill--alt">Outcomes</span>
            <h3 className="fpTitle">Placement Success</h3>
            <p className="fpDesc">
              Real learners, real journeys — quick highlights.
            </p>
          </div>
        </div>

        <div className="fpStrip" aria-label="Outcomes strip">
          <div className="fpTrack fpTrack--outcomes">
            {loopStories.map((s, i) => (
              <article className="fpStory" key={`${s.name}-${i}`}>
                <div className="fpStoryTop">
                  <div className="fpStoryName">{s.name}</div>
                  <span className="fpTag">{s.tag}</span>
                </div>
                <div className="fpStoryRole">{s.role}</div>
                <div className="fpStoryMetric">{s.metric}</div>
              </article>
            ))}
          </div>
        </div>

        <Link to="/about" className="fpBtn fpBtn--outcomes">
          View Success Stories <span aria-hidden="true">→</span>
        </Link>
      </div>
    </div>
  );
};

export default FeaturesPanel;